import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getComando as getComandoSdk,
  getComandos as getComandosSdk,
  getComandosConector as getComandosConectorSdk,
  postComandos as postComandosSdk,
} from '@sdk/Conectores/Comandos';

//Action Types
export const Types = {
  GET_COMANDOS: 'GET_COMANDOS',
  GET_COMANDOS_SUCCESS: 'GET_COMANDOS_SUCCESS',
  GET_COMANDOS_ERROR: 'GET_COMANDOS_ERROR',

  GET_COMANDO: 'GET_COMANDO',
  GET_COMANDO_SUCCESS: 'GET_COMANDO_SUCCESS',
  GET_COMANDO_ERROR: 'GET_COMANDO_ERROR',

  GET_COMANDOS_CONECTOR: 'GET_COMANDOS_CONECTOR',
  GET_COMANDOS_CONECTOR_SUCCESS: 'GET_COMANDOS_CONECTOR_SUCCESS',
  GET_COMANDOS_CONECTOR_ERROR: 'GET_COMANDOS_CONECTOR_ERROR',

  POST_COMANDOS: 'POST_COMANDOS',
  POST_COMANDOS_SUCCESS: 'POST_COMANDOS_SUCCESS',
  POST_COMANDOS_ERROR: 'POST_COMANDOS_ERROR',

  SET_COMANDOS_CONECTORES_SELECIONADOS: 'SET_COMANDOS_CONECTORES_SELECIONADOS',

  RESET_COMANDOS: 'RESET_COMANDOS',
};

//Action Creators
export const getComandos = (page = 1) => ({ type: Types.GET_COMANDOS, page });
export const getComandosSuccess = (data) => ({ type: Types.GET_COMANDOS_SUCCESS, data });
export const getComandosError = (error) => ({ type: Types.GET_COMANDOS_ERROR, error });

export const getComando = (idConfiguracao, id) => ({ type: Types.GET_COMANDO, idConfiguracao, id });
export const getComandoSuccess = (data) => ({ type: Types.GET_COMANDO_SUCCESS, data });
export const getComandoError = (error) => ({ type: Types.GET_COMANDO_ERROR, error });

export const getComandosConector = (idConfiguracao = -1, page = 1) => ({ type: Types.GET_COMANDOS_CONECTOR, idConfiguracao, page });

export const postComandos = (data) => ({ type: Types.POST_COMANDOS, data });
export const postComandosSuccess = () => ({ type: Types.POST_COMANDOS_SUCCESS });
export const postComandosError = (error) => ({ type: Types.POST_COMANDOS_ERROR, error });

export const setConectoresSelecionados = (conectoresSelecionados) => ({
  type: Types.SET_COMANDOS_CONECTORES_SELECIONADOS,
  conectoresSelecionados,
});

export const reset = () => ({ type: Types.RESET_COMANDOS });

//saga
function* fetchGetComandos(action) {
  try {
    const { page } = action;
    const comandos = yield call(getComandosSdk, page);
    yield put(getComandosSuccess(comandos));
  } catch (err) {
    Notification.error(err.message);
    yield put(getComandosError(err));
  }
}

function* fetchGetComando(action) {
  try {
    const { idConfiguracao, id } = action;
    const comando = yield call(getComandoSdk, idConfiguracao, id);
    yield put(getComandoSuccess(comando));
  } catch (err) {
    Notification.error(err.message);
    yield put(getComandoError(err));
  }
}

function* fetchGetComandosConector(action) {
  try {
    const { page, idConfiguracao } = action;
    const comandos = yield call(getComandosConectorSdk, idConfiguracao, page);
    yield put(getComandosSuccess(comandos));
  } catch (err) {
    Notification.error(err.message);
    yield put(getComandosError(err));
  }
}

function* fetchPostComandos(action) {
  try {
    const { data } = action;
    const comandos = yield call(postComandosSdk, data);
    yield put(postComandosSuccess(comandos));
  } catch (err) {
    Notification.error(err.message);
    yield put(postComandosError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_COMANDOS, fetchGetComandos),
  takeLatest(Types.GET_COMANDO, fetchGetComando),
  takeLatest(Types.GET_COMANDOS_CONECTOR, fetchGetComandosConector),
  takeLatest(Types.POST_COMANDOS, fetchPostComandos),
];

// Reducer
const initialState = Map({
  comandos: List(),
  comando: {},
  conectoresSelecionados: [],
  xTotalPage: 0,
  xCurrentPage: 0,

  loadingComandos: false,
  successComandos: false,
  errorComandos: false,
  hasMoreComandos: false,

  loadingComando: false,
  successComando: false,
  errorComando: false,

  loadingPostComandos: false,
  successPostComandos: false,
  errorPostComandos: false,
});

const handleGetComandos = (state, action) => {
  return state.set('loadingComandos', true).set('successComandos', false).set('errorComandos', false);
};

const handleGetComandosSuccess = (state, action) => {
  const { comandos, xTotalPage, xCurrentPage } = action.data;
  let todosComandos = List([...state.get('comandos').toArray(), ...comandos]);
  return state
    .set('comandos', todosComandos)
    .set('xTotalPage', xTotalPage)
    .set('xCurrentPage', xCurrentPage)
    .set('hasMoreComandos', xTotalPage !== xCurrentPage)
    .set('loadingComandos', false)
    .set('successComandos', true)
    .set('errorComandos', false);
};

const handleGetComandosError = (state, action) => {
  return state.set('loadingComandos', false).set('successComandos', false).set('errorComandos', action.error);
};

const handlePostComandos = (state, action) => {
  return state.set('loadingPostComandos', true).set('successPostComandos', false).set('errorPostComandos', false);
};

const handlePostComandosSuccess = (state, action) => {
  return state.set('loadingPostComandos', false).set('successPostComandos', true).set('errorPostComandos', false);
};

const handlePostComandosError = (state, action) => {
  return state.set('loadingPostComandos', false).set('successPostComandos', false).set('errorPostComandos', action.error);
};

const handleGetComando = (state, action) => {
  return state.set('loadingComando', true).set('successComando', false).set('errorComando', false);
};

const handleGetComandoSuccess = (state, action) => {
  const { data } = action;

  return state.set('comando', data[0]).set('loadingComando', false).set('successComando', true).set('errorComando', false);
};

const handleGetComandoError = (state, action) => {
  return state.set('loadingComando', false).set('successComando', false).set('errorComando', action.error);
};

const handleConectoresSelecionados = (state, action) => {
  const { conectoresSelecionados } = action;
  return state.set('conectoresSelecionados', conectoresSelecionados);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_COMANDOS:
      return handleGetComandos(state, action);
    case Types.GET_COMANDOS_SUCCESS:
      return handleGetComandosSuccess(state, action);
    case Types.GET_COMANDOS_ERROR:
      return handleGetComandosError(state, action);

    case Types.GET_COMANDO:
      return handleGetComando(state, action);
    case Types.GET_COMANDO_SUCCESS:
      return handleGetComandoSuccess(state, action);
    case Types.GET_COMANDO_ERROR:
      return handleGetComandoError(state, action);

    case Types.GET_COMANDOS_CONECTOR:
      return handleGetComandos(state, action);

    case Types.POST_COMANDOS:
      return handlePostComandos(state, action);
    case Types.POST_COMANDOS_SUCCESS:
      return handlePostComandosSuccess(state, action);
    case Types.POST_COMANDOS_ERROR:
      return handlePostComandosError(state, action);

    case Types.SET_COMANDOS_CONECTORES_SELECIONADOS:
      return handleConectoresSelecionados(state, action);

    case Types.RESET_COMANDOS:
      return handleReset(state, action);

    default:
      return state;
  }
}
